import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class ActivitySkills extends Component {
    render() {
        const { skills } = this.props;

        this.options = {
            defaultSortName: 'datasetNumber',
            defaultSortOrder: 'asc'
          };

        return (
            <div>
                <div className="activity-skills-header">
                    <h3>Activity Skill Details</h3>
                </div>
                <BootstrapTable striped condensed data={skills} options={this.options} multiColumnSort={2}>
                    <TableHeaderColumn dataField='skillId' isKey hidden={true}>skillId</TableHeaderColumn>
                    <TableHeaderColumn dataField='datasetNumber' dataSort width='10%'>Dataset</TableHeaderColumn>
                    <TableHeaderColumn dataField='skillName' dataSort>Skill Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='skillGroupName' dataSort>Skill Group Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='skillTypeName' dataSort width='20%'>Skill Type Name</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

ActivitySkills.propTypes = {
    skills: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired
};

export default ActivitySkills;



// WEBPACK FOOTER //
// ./src/components/activitySkills/ActivitySkills.js